var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.29716 0.189691L9.35344 1.9448L12.3877 1.84751L4.35601 10.7402L5.58741 11.9394L13.6191 3.04665L13.7201 6.19706L15.4105 6.14286L15.2135 -1.05209e-05M13.9733 14.095L2.1406 14.4744L1.74667 2.1887L7.66305 1.999L7.60677 0.243891L1.69039 0.433593C0.752225 0.463674 0.0253239 1.27759 0.0562753 2.2429L0.450203 14.5286C0.465128 14.9941 0.657536 15.4348 0.9851 15.7538C1.31266 16.0728 1.74855 16.2439 2.19687 16.2295L14.0296 15.8501C14.4779 15.8358 14.902 15.6371 15.2084 15.2978C15.5149 14.9585 15.6787 14.5063 15.6637 14.0408L15.4668 7.89797L13.7764 7.95217L13.9733 14.095Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/external-link.d509ad88.svg";
export { ForwardRef as ReactComponent };